export class ModelBase {
  delFlag: number;
  createTime?: Date;
  createUserId?: string;
  changeTime?: Date;
  changeUserId?: string;
  deleteTime?: Date;
  deleteUserId?: string;
}
